export class AdditionalInformationSectionConsts {

  static VIN = 'vin';
  static TECHNICAL_INSPECTION_DATE = 'technicalInspectionDate';
  static KEYS_AMOUNT = 'keysAmount';
  static ORIGINAL_KEYS_AMOUNT = 'originalKeysAmount';
  static LEECHED_KEYS_AMOUNT = 'leechedKeysAmount';
  static IMMOBILIZER = 'immobilizer';
  static MECHANIC_LOCK_TRANSMISSION = 'mechanicLockTransmission';
  static AUTOALARM = 'autoalarm';
  static GPS = 'gps';
  static USA_CANADA_REGISTRATION = 'usaCanadaRegistration';
  static OTHER_SECURITIES = 'otherSecurities';
}
